<template>
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.25 4.5C12.25 2.70507 13.7051 1.25 15.5 1.25C17.2949 1.25 18.75 2.70507 18.75 4.5C18.75 6.29493 17.2949 7.75 15.5 7.75C14.5404 7.75 13.6779 7.33409 13.083 6.6727L10.3657 8.15487L8.84541 9.02359L7.32515 9.89231C7.59552 10.3664 7.75 10.9152 7.75 11.5C7.75 11.7963 7.71034 12.0834 7.63603 12.3562L13.083 15.3273C13.6779 14.6659 14.5404 14.25 15.5 14.25C17.2949 14.25 18.75 15.7051 18.75 17.5C18.75 19.2949 17.2949 20.75 15.5 20.75C13.7051 20.75 12.25 19.2949 12.25 17.5C12.25 17.2036 12.2897 16.9166 12.364 16.6438L6.91704 13.6727C6.32212 14.3341 5.45963 14.75 4.5 14.75C2.70507 14.75 1.25 13.2949 1.25 11.5C1.25 9.70507 2.70507 8.25 4.5 8.25C5.15068 8.25 5.7567 8.44122 6.26492 8.77052L9.63435 6.84514L12.364 5.35625C12.2897 5.08344 12.25 4.79635 12.25 4.5Z" stroke="#130F26" stroke-linecap="round"/>
    </svg>
</template>

<script>
    export default {
        name: "SiteIcon"
    }
</script>

<style scoped>

</style>